export default __webpack_public_path__ + "static/media/portfolio-193.b66183b1.jpg";